import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { useClientId } from '../../_hooks/useClientId';

const removeAlignment = (clientId: number) => async (alignmentId: string): Promise<null> => {
  return authFetch(
    urlWithParams('/BeFi20/survey/RemoveAlignment', { clientId, alignment: alignmentId }),
    {
      method: 'POST',
    },
  );
};

export const useRemoveAlignmentMutation = () => {
  const queryClient = useQueryClient();
  const clientId = useClientId();

  return useMutation(removeAlignment(clientId), {
    async onSuccess() {
      await queryClient.invalidateQueries(queryKeys.overview(clientId));
    },
  });
};
